import { CommitAction } from '../../utils/commit-action';

let serverAddress = process.env.REACT_APP_API_ADDRESS;
let apiPrefix = process.env.REACT_APP_API_PREFIX;
let ruleSetUuid = process.env.REACT_APP_RULE_SET_UUID;
let commitAction = process.env.REACT_APP_COMMIT_ACTION || CommitAction.SEND_TO_PARENT_IFRAME;

/**
 * Kit Builder is served from the same host as the configurator API (so it keeps
 * using getServerAddress()), but under its own path prefix instead of /api/v1.
 * Override with REACT_APP_KIT_API_PREFIX if the backend ever moves it again.
 */
const KIT_API_PREFIX_DEFAULT = '/public/api';

let kitApiPrefix = process.env.REACT_APP_KIT_API_PREFIX || KIT_API_PREFIX_DEFAULT;

export const getServerAddress = () => serverAddress;

export const setServerAddress = (address: string) => {
  serverAddress = address;
};

export const getApiPrefix = () => apiPrefix;

export const setApiPrefix = (prefix: string) => {
  apiPrefix = prefix;
};

export const getRuleSetUuid = () => ruleSetUuid;

export const setRuleSetUuid = (uuid: string) => {
  ruleSetUuid = uuid;
};

export const getCommitAction = () => commitAction;

export const setCommitAction = (action: CommitAction) => {
  commitAction = action;
};

export const getKitApiPrefix = () => kitApiPrefix;

export const setKitApiPrefix = (prefix: string) => {
  kitApiPrefix = prefix;
};
